// extracted by mini-css-extract-plugin
export default {"Position":"UjaXa","skeleton-progress":"EdmI2"};